import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import contractBgOrange from '../../assets/images/contract_bg_orange.png';
// import notActiveOrderBg from '../../assets/images/not_active_contract_bg.png';

const StyledInfoContainer = styled.div`
	height: 100%;
	padding-top: 17px;
`;

const StyledActiveOrderInfoContainer = styled.div<{
	$isActive: boolean;
	$state?: 'tags' | 'time';
}>`
	display: grid;
	grid-template-columns: ${({ $isActive }) =>
		$isActive ? '60px 1fr 40px' : '60px 1fr'};
	gap: 20px;
	align-items: center;
	height: 100px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	padding: 0 20px;

	${({ $state }) =>
		$state === 'tags' &&
		css`
			background-image: url(${contractBgOrange});
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
		`}
	img {
		user-select: none;
		pointer-events: none;
	}

	${({ $isActive }) =>
		!$isActive &&
		css`
			${StyledInfoContainer} {
				padding-top: 0;
				height: auto;
			}
		`}
`;

const StyledTagsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-top: 9px;
`;

const StyledTag = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	padding: 0 5px;
	border-radius: 5px;
	background-color: rgba(255, 255, 255, 0.05);

	${Text} {
		font-weight: 500;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledNotActivePicContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 60px;
	height: 60px;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 5px;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
		opacity: 0.25;
	}
`;

const StyledTimeContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	margin-top: 12px;
`;

export {
	StyledActiveOrderInfoContainer,
	StyledInfoContainer,
	StyledNotActivePicContainer,
	StyledTag,
	StyledTagsContainer,
	StyledTimeContainer,
};
